module.exports = __webpack_public_path__ + "static/media/logo-banner-2021.ef55361b.png";